/**
 * Type of note that comes from Bazan
 * Should be in sync with Bazan note type field accordingly
 */
export const BazanNoteType = {
  M1Note: 'M1',
  M2Note: 'M2',
  General: 'הודעה כללית',
} as const;
export type BazanNoteType = (typeof BazanNoteType)[keyof typeof BazanNoteType];

/**
 * Field keys that come from Bazan
 */
export const BazanFieldKey = {
  FunctionalLocation: 'functionalLocation',
  Priority: 'priority',
  FaultSource: 'faultSource',
  EquipmentFailure: 'equipmentFailure',
  Equipment: 'equipment',
  NoteType: 'noteType',
} as const;
export type BazanFieldKey = (typeof BazanFieldKey)[keyof typeof BazanFieldKey];

export const BazanFieldGroup = {
  TaskInfo: 'task-info',
  Details: 'details',
} as const;
export type BazanFieldGroup = (typeof BazanFieldGroup)[keyof typeof BazanFieldGroup];

export const BazanPriorityValues = {
  Highest: '1',
  High: '2',
  Medium: '3',
  Low: '4',
} as const;
export type BazanPriorityValues = (typeof BazanPriorityValues)[keyof typeof BazanPriorityValues];
